import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Accordion, Card, useAccordionToggle } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { setUser } from '../../../../redux/actions/user.actions';
import { pageTitle } from '../../../../redux/actions/home.actions';
import webServices from '../../../../services/webServices';
// import MyAffiliateInfo from './MyAffiliateInfo';
import MyEarnings from './MyEarnings';
import MyReferals from './MyReferals';
import MakeMoneyPopup from './MakeMoneyPopup';
import TermsAndServicePopup from './TermsAndServicePopup';
import AppConstants from '../../../../appConstants';
import SocialShareBarComponent from './SocialShareBarComponent';
import copy from '../../../../assets/images/affiliate/copy.svg';

const AccordionCustomToggle = ({
  title,
  eventKey,
  parentCallBack,
  status,
  arrowRight
}) => {
  // const decoratedOnClick = useAccordionToggle(eventKey);
  const decoratedOnClick = useAccordionToggle(eventKey, () => {
    const accStatus = status === 'open' ? 'close' : 'open';
    parentCallBack(eventKey, accStatus);
  });

  return (
    <div
      className="card-link"
      onClick={() => decoratedOnClick(title, status)}
      onKeyDown={(event) => event.key === 'Enter' && decoratedOnClick()}
      role="button"
      tabIndex="0"
    >
      <span>{title}</span>
      {arrowRight ? (
        <span>
          <i className="fa fa-angle-left" />
        </span>
      ) : (
        <span>
          {status === 'open' ? (
            <i className="fa fa-minus" />
          ) : (
            <i className="fa fa-plus" />
          )}
        </span>
      )}
    </div>
  );
};

const DashboardPage = () => {
  // const myRef = useRef(null);
  const location = useLocation();
  const [profilePic, setProfilePic] = useState('no_Image.svg');
  const [userName, setUserName] = useState('');
  const [userAdd, setUserAdd] = useState('City, State, Country');
  const [userOccupation, setUserOccupation] = useState('');
  const dispatch = useDispatch();
  const userDetails = useSelector((state) => (state.user && state.user.current) || null);
  const URL = `${process.env.REACT_APP_BASE_URL}/register?referralCode=${userDetails?.my_referral_code}`;

  const [initOcc, setInitOcc] = useState(location?.state?.occordian || '0');

  const [accStatus, setAccStatus] = useState({
    personal: 'open',
    basic: 'close',
    lifestyle: 'close'
  });

  const [verifyMsg, setVerifyMsg] = useState(
    // !userDetails?.zelle_phone_no || false
    false
  );
  const handleCloseVerifyMsg = () => setVerifyMsg(false);

  const [termsMsg, setTermsMsg] = useState(false);
  const handleCloseTermsMsg = () => setTermsMsg(false);
  const handleOpenTermsMsg = () => setTermsMsg(true);

  const [copied, setCopied] = useState(0);

  useEffect(async () => {
    dispatch(pageTitle('Dashboard'));
  }, [dispatch]);

  useEffect(async () => {
    const resp = await webServices.getUserDetail();
    if (resp && resp.success === true) {
      dispatch(setUser(resp.data));
    }
  }, []);

  useEffect(() => {
    if (userDetails && userDetails.id) {
      setProfilePic(userDetails.profile_image || 'no_Image.svg');
      setUserName(
        `${userDetails.first_name || ''} ${userDetails.last_name || ''}`.trim()
      );
      setUserAdd(
        `${userDetails.cityLabel ? `${userDetails.cityLabel}, ` : ''}
        ${userDetails.stateLabel ? `${userDetails.stateLabel}, ` : ''}
        ${userDetails.countryLabel || ''}`
      );

      setUserOccupation(`${userDetails.occupationLabel || ''}`);
    }
  }, [dispatch, userDetails]);

  const callBack = (key, data) => {
    const init = { ...accStatus };
    init.personal = 'close';
    init.basic = 'close';
    init.lifestyle = 'close';

    if (key === '0') {
      init.personal = data;
    }
    if (key === '1') {
      init.basic = data;
    }
    if (key === '2') {
      init.lifestyle = data;
    }
    setAccStatus(init);
    if (data === 'close') {
      setInitOcc(null);
    } else {
      setInitOcc(key);
    }
  };

  const handleClicOpenAccordian = (val, scroll) => {
    callBack(val, 'open');
    setTimeout(() => {
      window.scrollTo(0, scroll);
    }, 500);
  };

  const copyToClipboard = (id, text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopied(id);
        setTimeout(() => setCopied(0), 2000);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error('Failed to copy: ', err);
      });
  };

  return (
    <>
      <div className="inner-wrapper-newdesign profile-wrapper-outer">
        <div className="largeScreen">
          <div className="row">
            <div className="col-md-12 profile-box profile-wrapper">
              <div className="image-slider-box cursor-pointer">
                <div
                  className="user-profile-image"
                  style={{
                    backgroundImage: `url("${process.env.REACT_APP_PIC_BASE_URL + profilePic}")`
                  }}
                />
              </div>
              <div className="user-detail-box profileSection">

                <div className="card userCard">
                  <div className="card-body">
                    <div className="usr-info-box">
                      <h5>
                        <span className="profile_name" title={userName}>
                          {userName}
                        </span>
                      </h5>
                      {userOccupation ? (
                        <p
                          className="occupation cursor-pointer"
                          aria-hidden="true"
                          onClick={() => handleClicOpenAccordian('1', 1450)}
                        >
                          {userOccupation} ({userDetails?.userDetails?.jobTitle})
                          {/* <br /> */}
                          {userDetails?.userDetails?.companyName ? ' at ' : ''}
                          {userDetails?.userDetails?.companyName}
                        </p>
                      ) : (
                        <p
                          className="occupation missting_section_match cursor-pointer"
                          aria-hidden="true"
                          onClick={() => handleClicOpenAccordian('1', 1450)}
                        >
                          Occupation to be added
                        </p>
                      )}

                      {userAdd && <p className="address">{userAdd}</p>}
                    </div>
                    <div className='mt-4'>
                      <div className='colorHead'>Earn Money by Spreading Love and Happiness!</div>
                      <div>30% of Revenue Paid Directly to You! Receive your payments regularly and with ease.*</div>
                      <a className='learmore' href={AppConstants.routes.affiliate.home} rel="noreferrer" target="_blank">learn more about our affiliate program</a>
                    </div>
                    <hr />
                    <div className="row mb-4 mt-4">
                      <div className="col-12">
                        <div className="colorHead">Share on social media:</div>
                      </div>
                      <div className="col-12 mb-2">
                        <SocialShareBarComponent message={URL} />
                      </div>
                    </div>
                    <hr />
                    <div className="row mt-4">
                      <div className="col-12">
                        <div className="colorHead">My Affiliate link:</div>
                        <div className="dec"><i className="fa fa-link mr-2" /> {URL}</div>
                      </div>
                      <div className="col-12 mt-4 align-self-end">
                        <div className="copyWrapper">
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => copyToClipboard(1, URL)}
                          >
                            <img src={copy} className="img-fluid" alt="arrow icon" /> Copy
                          </button>
                          {copied === 1 && <div className="toolTip">Link copied!</div>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <Accordion
                // defaultActiveKey={initOcc}
                activeKey={initOcc}
                className="profile-accordion new_profile_accordion mt-4"
              >
                {/* <Card ref={myRef}>
                  <Card.Header className="pb-2">
                    <AccordionCustomToggle
                      eventKey="0"
                      title="My Affiliate Info"
                      status={accStatus.personal}
                      parentCallBack={callBack}
                    />
                  </Card.Header>
                  <Accordion.Collapse eventKey="0">
                    <Card.Body>
                      <MyAffiliateInfo userDetail={userDetails} />
                    </Card.Body>
                  </Accordion.Collapse>
                </Card> */}
                <Card>
                  <Card.Header className="pb-2">
                    <AccordionCustomToggle
                      eventKey="1"
                      title="My Earnings"
                      status={accStatus.basic}
                      parentCallBack={callBack}
                    />
                  </Card.Header>
                  <Accordion.Collapse eventKey="1">
                    <Card.Body>
                      <MyEarnings />
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <Card.Header className="pb-2">
                    <AccordionCustomToggle
                      eventKey="2"
                      title="My Referrals"
                      status={accStatus.lifestyle}
                      parentCallBack={callBack}
                    />
                  </Card.Header>
                  <Accordion.Collapse eventKey="2">
                    <Card.Body>
                      <MyReferals />
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            </div>
          </div>
        </div>
      </div>
      <MakeMoneyPopup
        modalStatus={verifyMsg}
        handleClose={handleCloseVerifyMsg}
        userDetails={userDetails}
        handleOpenTerms={handleOpenTermsMsg}
      />
      <TermsAndServicePopup
        modalStatus={termsMsg}
        handleClose={handleCloseTermsMsg}
      />
    </>
  );
};

export default DashboardPage;
